import React from 'react';
import Navbar from './../pages/Navbar';
import Footer from './../pages/Footer';

function About() {
  return (
   <div>
    <Navbar />
    <>
    <div className="card-header align-items-center px-3 px-md-5 text-center mt-3">
            <h2>About Us</h2>
        </div>
    </>
    <Footer/>
  </div>
  );
}

export default About;
